import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const FamilyMedicineIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M80.2144 40C80.2144 61.8153 62.5296 79.5 40.7144 79.5C18.8991 79.5 1.21436 61.8153 1.21436 40C1.21436 18.1848 18.8991 0.5 40.7144 0.5C62.5296 0.5 80.2144 18.1848 80.2144 40Z'
    />
    <g clipPath='url(#clip0_414_12945)'>
      <path
        d='M58.8014 35.1916L56.7334 31.6821L55.98 30.9167H51.6605L49.8599 33.0965L47.9799 37.2213L48.1787 37.9867L47.8813 38.2232L47.7275 38.6896H58.5958L59.8841 37.9866C59.6779 37.0065 59.3142 36.0619 58.8014 35.1916Z'
        fill='#DBEDFF'
      />
      <path
        d='M48.1785 37.9867C48.3846 37.0065 48.7483 36.0619 49.2611 35.1916L51.3291 31.6821L52.0232 30.9167H46.4224L45.7282 31.6821L43.6603 35.1916C43.1475 36.0619 42.7837 37.0065 42.5776 37.9867L43.354 38.6897H48.9549L48.1785 37.9867Z'
        fill='#B5DCFF'
      />
      <path
        d='M38.5407 35.275V32.8797C38.5407 31.1349 37.1263 29.7205 35.3814 29.7205C33.6366 29.7205 32.2222 31.1349 32.2222 32.8797V35.275H38.5407Z'
        fill='#FFAFE2'
      />
      <path
        d='M32.2222 35.1743V37.4689C32.2222 39.2138 33.6366 40.6282 35.3814 40.6282C37.1263 40.6282 38.5407 39.2138 38.5407 37.4689V35.1743H32.2222Z'
        fill='#FF3581'
      />
      <path
        d='M59.8838 37.9868H48.1784L47.8811 38.2233L47.4912 39.4055V53.1003H50.2741L59.7021 49.6546L60.0825 49.1823V39.8905C60.0826 39.2479 60.0148 38.6103 59.8838 37.9868Z'
        fill='#1CA8FF'
      />
      <path
        d='M47.9799 53.1003V39.8905C47.9799 39.248 48.0477 38.6104 48.1787 37.9868H42.5777C42.4467 38.6103 42.3789 39.248 42.3789 39.8905V47.4566V47.9695L46.9255 50.3841V53.1004H47.9799V53.1003Z'
        fill='#0094FD'
      />
      <path
        d='M53.9932 43.4025H51.9853V41.3946C51.9853 40.9779 51.6475 40.6401 51.2308 40.6401C50.8141 40.6401 50.4763 40.9779 50.4763 41.3946V43.4025H48.4684C48.0517 43.4025 47.7139 43.7403 47.7139 44.157C47.7139 44.5737 48.0517 44.9115 48.4684 44.9115H50.4763V46.9194C50.4763 47.3361 50.8141 47.6739 51.2308 47.6739C51.6475 47.6739 51.9853 47.3361 51.9853 46.9194V44.9115H53.9932C54.4099 44.9115 54.7477 44.5737 54.7477 44.157C54.7477 43.7403 54.4099 43.4025 53.9932 43.4025Z'
        fill='#DBEDFF'
      />
      <path
        d='M61.5391 15C61.5053 15 61.472 15.0018 61.4385 15.0025V23.3477C61.4721 23.3484 61.5054 23.3502 61.5391 23.3502C63.8449 23.3502 65.7142 21.481 65.7142 19.1751C65.7142 16.8692 63.8449 15 61.5391 15Z'
        fill='#FFE02F'
      />
      <path
        d='M57.3643 19.1751C57.3643 21.481 59.2335 23.3502 61.5394 23.3502V15C59.2335 15 57.3643 16.8692 57.3643 19.1751Z'
        fill='#FBC700'
      />
      <path
        d='M56.7331 26.3481H50.9005C50.7113 26.4125 50.5596 26.4649 50.5596 26.4649L50.0942 27.1817V30.9167L50.3583 31.4449L51.0399 31.682H56.733C57.3822 31.682 57.9086 31.1558 57.9086 30.5065V27.5236C57.9087 26.8744 57.3823 26.3481 56.7331 26.3481Z'
        fill='#BF7FE3'
      />
      <path
        d='M50.2313 30.5065V27.5236C50.2313 26.8744 50.7577 26.3481 51.4068 26.3481H45.7283C45.0791 26.3481 44.5527 26.8744 44.5527 27.5236V30.5065C44.5527 31.1558 45.0791 31.682 45.7283 31.682H51.4068C50.7577 31.682 50.2313 31.1558 50.2313 30.5065Z'
        fill='#B166DB'
      />
      <path
        d='M65.4289 50.2771C64.1313 47.5674 61.1448 48.8482 60.894 48.9421L48.5555 52.5924C48.4081 52.6359 48.2683 52.5086 48.2957 52.3574C48.4278 51.6301 48.4962 49.909 46.454 49.0939C39.1691 46.1857 38.3004 45.6939 36.4567 45.6647L36.4565 45.6646C30.7572 45.6836 29.7247 45.7301 26.8924 46.9979C26.6599 47.102 26.4298 47.2106 26.201 47.3216L25.2453 48.652L24.2393 52.039L24.6081 55.4027L26.9556 59.4167L29.0834 60.343C31.6903 59.5133 34.4133 59.4379 36.5996 60.3103L41.3008 62.187C42.3284 62.5412 44.6891 63.0927 47.1387 61.8371C47.1398 61.8365 47.1407 61.8361 47.1407 61.8361C47.3691 61.7351 49.4475 60.8157 52.0536 59.663L55.2739 58.2385C59.242 56.4832 63.2325 54.7181 63.5528 54.5765C64.0498 54.3216 66.5485 52.8225 65.4289 50.2771Z'
        fill='#FFDECF'
      />
      <path
        d='M24.6415 52.5323C24.6415 50.5004 25.3494 48.6349 26.53 47.1653C25.181 47.7951 23.895 48.5405 22.6847 49.3913C21.8221 49.9976 20.8649 50.4568 19.8482 50.7363L16.3886 51.6875C15.9903 51.797 15.7144 52.159 15.7144 52.5721V64.0816C15.7144 64.7238 16.3571 65.1672 16.9575 64.9393L28.985 60.373C29.1362 60.3237 29.288 60.2776 29.4399 60.2334C26.598 58.836 24.6415 55.9131 24.6415 52.5323Z'
        fill='#FFCEBE'
      />
      <path
        d='M48.5554 52.5925C48.5035 52.6078 48.4529 52.6011 48.4099 52.5805L48.3848 52.6378C48.3722 52.6666 48.3613 52.6963 48.3523 52.7264C48.308 52.8763 47.8778 54.1815 46.4337 53.8275C44.2748 53.2986 38.2751 51.8148 38.2147 51.7998C37.8102 51.6998 37.4012 51.9467 37.3011 52.3511C37.201 52.7556 37.4478 53.1647 37.8523 53.2648C37.9127 53.2797 43.914 54.764 46.0746 55.2933C46.3825 55.3688 46.6697 55.4027 46.9373 55.4027C48.6186 55.4027 49.5136 54.058 49.7845 53.2032L50.2743 52.0839L48.5554 52.5925Z'
        fill='#FFB1A0'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_12945'>
        <rect width='50' height='50' fill='white' transform='translate(15.7144 15)' />
      </clipPath>
    </defs>
  </svg>
));
FamilyMedicineIcon.displayName = 'FamilyMedicineIcon';

export default FamilyMedicineIcon;
